// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2VNgR","name":"Header_name__g-5zh","birthday":"Header_birthday__36zhm","skeleton":"Header_skeleton__2mmk_"};